import { Stack, Typography } from '@lyearn/ui';

import { DialogHeaderProps } from './types';

const DialogHeader = (props: DialogHeaderProps) => {
  const { className = 'px-24 pt-28', title, description, overrides } = props;

  return (
    <Stack className={className} direction="col">
      <Typography
        className="ps-8 pe-40"
        color="text-text-primary"
        variant="heading-m"
        {...overrides?.title}>
        {title}
      </Typography>
      <Typography
        className="mt-4 ps-8 pe-40"
        color="text-text-secondary"
        variant="body-short-01"
        {...overrides?.description}>
        {description}
      </Typography>
    </Stack>
  );
};

export default DialogHeader;
